import { Modal } from "bootstrap";
import { nothing, render, TemplateResult } from "lit";
import { I18n } from "@/i18n/i18n";

function ensureInfoModal(): void {
    if (document.getElementById("info-modal")) return;
    const el = document.createElement("div");
    el.id = "info-modal";
    el.className = "modal fade";
    el.tabIndex = -1;
    el.innerHTML = `
        <div class="modal-dialog modal-xl modal-fullscreen-lg-down tutor">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"></h4>
                    <div class="icons">
                        <span class="modal-actions"></span>
                        <button type="button" class="btn btn-icon btn-icon-muted" data-bs-dismiss="modal" title="${I18n.t("js.close")}" aria-label="${I18n.t("js.close")}">
                            <i class="mdi mdi-close" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div class="modal-body"></div>
            </div>
        </div>
    `;
    document.body.appendChild(el);
}

function showInfoModal(
    title: TemplateResult | string,
    content: TemplateResult | string,
    actions?: TemplateResult,
): void {
    ensureInfoModal();
    render(title, document.querySelector("#info-modal .modal-title") as HTMLElement);
    render(actions ?? nothing, document.querySelector("#info-modal .modal-actions") as HTMLElement);
    render(content, document.querySelector("#info-modal .modal-body") as HTMLElement);

    const modal = new Modal(document.getElementById("info-modal"));
    modal.show();
}

export { showInfoModal };
